import { Component, OnDestroy, Input, OnInit, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { LocalDate } from '../../../core/model/local-date';
import { CompanyService } from '../../service/data/company.service';
import { Company } from '../../model/company';
import { LanguageService } from '../../../core/service/language.service';
import { NavigationService } from '../../../core/service/navigation.service';

@Component({
    selector: 'app-company-hogia-config',
    templateUrl: './company-hogia-config.component.html',
    styleUrls: ['./company-hogia-config.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyHogiaConfigComponent implements OnDestroy, OnInit {
  constructor(
    private _companyService: CompanyService,
    private _modalService: ActionWindowService,
    private _languageService: LanguageService
  ) {}
  hogiaOBUrl: string;

  @Output() onSave = new EventEmitter();

  public errorMessage: string;
  private _subscription: Subscription = new Subscription();

  dataContext: Company;
  readonly form: FormGroup;

  isEnabled: boolean = false;

  close() {
    this._modalService.close();
  }

  redirect() {
    this.onSave.emit();
    this._modalService.complete(true);
  }

  ngOnInit(): void {
    this._subscription.add(
      this._companyService.getOpenBusinessUrl().subscribe(
        res => {
          if (!res) return;

          this.isEnabled = true;
          this.hogiaOBUrl = res;
        },
        err => {
          this.setError(err);
        }
      )
    );
  }

  private setError(error: any) {
    if (error.error && error.error.message) {
      this.errorMessage = error.error.message;
    } else {
      this.errorMessage = this._languageService.getText('HOGIA.GENERAL_ERROR');
    }
  }

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = null;
    }
  }
}
